import { z } from 'zod';
import type {
  GetInboundReceiptDraftRequest,
  GetInboundReceiptDraftResponse,
} from './get-inbound-receipt-draft.dto.js';
import { InboundReceiptDraftSchema } from './inbound-receipts-shared.schema.js';

export const GetInboundReceiptDraftRequestSchema: z.ZodType<GetInboundReceiptDraftRequest> = z
  .object({
    companyId: z.uuid(),
    draftId: z.uuid(),
  })
  .strict();

export const GetInboundReceiptDraftResponseSchema: z.ZodType<GetInboundReceiptDraftResponse> = z
  .object({
    draft: InboundReceiptDraftSchema,
  })
  .strict();
